import classNames from "classnames"
import React from "react"

type ButtonProps = {
  children: React.ReactNode
  className?: string
  variant?: "default" | "outline" | "secondary"
  href?: string
}

const baseStyles =
  "items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-11 rounded-md px-8"

const variants: Record<NonNullable<ButtonProps["variant"]>, string> = {
  default: "flex bg-primary text-white gap-1",
  outline:
    "inline-flex border border-input bg-background hover:bg-accent hover:text-accent-foreground gap-2",
  secondary:
    "flex bg-secondary text-secondary-foreground hover:bg-secondary/80 h-11 rounded-md",
}

export const Button = ({
  children,
  className,
  variant = "default",
  href,
}: ButtonProps) => {
  if (href) {
    return (
      <a
        href={href}
        className={classNames(baseStyles, variants[variant], className)}
      >
        {children}
      </a>
    )
  }
  return (
    <button className={classNames(baseStyles, variants[variant], className)}>
      {children}
    </button>
  )
}
